const genderChartBackgroundColor = ["#D3E87C", "#C4D26E", "#71E3FA", "#BBB"];
const customerChartBackgroundColor = [
  "#B9C478",
  "#71E3FA",
  "#D3E87C",
  "#BBBBBB",
];
const positiveNegativeBgColor = ["#C4D26E", "#FF6363"];

const overviewDashboardChart = {
  genderChartDatasetSettings: {
    backgroundColor: genderChartBackgroundColor, // colors for male and female
    hoverBackgroundColor: genderChartBackgroundColor, // hover colors
    borderWidth: 5, // Gap between sections (acts as space)
    borderColor: "#ffffff",
    borderRadius: 8,
    hoverBorderColor: "#ffffff", // Maintain gap color on hover
    hoverBorderWidth: 5,
  },
  customerChartDatasetSettings: {
    backgroundColor: customerChartBackgroundColor,
    hoverBackgroundColor: customerChartBackgroundColor,
    borderWidth: 5, // Gap between sections (acts as space)
    borderColor: "#ffffff",
    borderRadius: 8,
    hoverBorderColor: "#ffffff", // Maintain gap color on hover
    hoverBorderWidth: 5,
  },
};

const reviewDashboardChart = {
  positiveNegativeChart: {
    backgroundColor: positiveNegativeBgColor,
    hoverBackgroundColor: positiveNegativeBgColor,
    borderWidth: 5,
    borderColor: "#ffffff",
    borderRadius: 8,
    hoverBorderColor: "#ffffff", // Maintain gap color on hover
    hoverBorderWidth: 5,
  },
};

const doughnutChartCommonOptions = {
  plugins: {
    legend: {
      position: "right",
      labels: {
        usePointStyle: true, // Use circle points instead of squares
        boxWidth: 10, // Circle size
        boxHeight: 10,
        padding: 20, // Add spacing between legend items
        font: {
          size: 12,
        },
        generateLabels: (chart) => {
          const { data } = chart;
          return data.labels.map((label, i) => ({
            text: ` ${label}  ${data?.datasets[0]?.data[i]}%`,
            fillStyle: data?.datasets[0]?.backgroundColor[i],
            hidden: false,
            index: i,
            strokeStyle: data?.datasets[0]?.backgroundColor[i],
          }));
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  cutout: "60%",
  // maintainAspectRatio: false,
};

export {
  overviewDashboardChart,
  doughnutChartCommonOptions,
  reviewDashboardChart,
};
